module.exports = "<router-outlet></router-outlet>"


//////////////////
// WEBPACK FOOTER
// D:/projects/feelway-pawnshop/pawnshop-web-client-feelway/src/app/app.component.html
// module id = ../../../../../src/app/app.component.html
// module chunks = main